import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id A7CB61B3-B3C5-4EEE-AC94-D0B2347FFA1B
 * name post-outline
 * version: 4.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/post-outline.svg
 * tags
 */
export const PostOutlineIcon = createSvgIcon(<><path d="M19 5V19H5V5H19M21 3H3V21H21V3M17 17H7V16H17V17M17 15H7V14H17V15M17 12H7V7H17V12Z" /></>, 'PostOutlineIcon');
export default PostOutlineIcon